export default function getInitials (name = ''){
  return name.slice(0, 1).toUpperCase()
}
